import Quill from 'quill';
import * as Parchment from 'parchment';

// // ===== Custom Clipboard =====
// const Clipboard = Quill.import('modules/clipboard');
//
// class CustomClipboard extends Clipboard {
//     sanitize(html) {
//         const doc = new DOMParser().parseFromString(html, 'text/html');
//
//         doc.querySelectorAll('math-field').forEach(el => {
//             el.setAttribute('contenteditable', 'false');
//             el.setAttribute('tabindex', '-1');
//         });
//
//         return doc.body.innerHTML;
//     }
// }
//
// Quill.register('modules/clipboard', CustomClipboard, true);

let Inline = Quill.import('blots/inline');
// ===== Custom Inline Math Field Span Blot =====
class MathFieldSpanInlineBlot extends Inline {
    static blotName = 'math-field';
    static tagName = 'span';
    static className = 'math-field';

    static create(value) {
        const node = super.create();
        node.setAttribute('math-field', value);
        node.setAttribute('contenteditable', 'false');
        node.setAttribute('tabindex', '-1');
        node.setAttribute('value', value);
        node.innerText = value;
        return node;
    }

    static formats(node) {
        return node.getAttribute('value');
    }

    format(name, value) {
        if (name === 'math-field' && value) {
            this.domNode.setAttribute('value', value);
        } else {
            super.format(name, value);
        }
    }

    static value(node) {
        return node.getAttribute('value');
    }
}
MathFieldSpanInlineBlot.scope = Parchment.Scope.INLINE;
Quill.register(MathFieldSpanInlineBlot, true);

// // ===== Custom Math Field Inline Blot =====
// class MathFieldBlot extends Inline {
//     static blotName = 'math-field';
//     static tagName = 'span';
//     static className = 'math-field'
//
//     static create(value) {
//         const node = super.create();
//         node.setAttribute('value', value);
//         node.setAttribute('math-field', value);
//         node.innerText = value;
//         return node;
//     }
//
//     static formats(node) {
//         return node.getAttribute('value');
//     }
//
//     format(name, value) {
//         if (name === 'math-field' && value) {
//             this.domNode.setAttribute('value', value);
//             this.domNode.setAttribute('contenteditable', 'false');
//             this.domNode.setAttribute('tabindex', '-1');
//             this.domNode.setAttribute('math-field', value);
//             this.domNode.innerText = value;
//         } else {
//             super.format(name, value);
//         }
//     }
// }
//
// MathFieldBlot.scope = Parchment.Scope.INLINE;
//
// Quill.register(MathFieldBlot);
//
// // ===== Custom Embed Blot =====
// const Embed = Quill.import('blots/embed');
//
// class MathFieldEmbedBlot extends Embed {
//     static blotName = 'math-field-embed';
//     static tagName = 'span';
//     static className = 'math-field-embed';
//
//     static create(value) {
//         console.log('math-field-embed', value);
//         const node = super.create();
//         console.log(1);
//         node.setAttribute('contenteditable', 'false');
//         node.setAttribute('tabindex', '-1');
//         node.setAttribute('value', value);
//         node.setAttribute('math-field', value);
//         console.log({node});
//         node.innerHTML = value;
//         return node;
//     }
//
//     static value(node) {
//         return node.getAttribute('value');
//     }
// }
//
// MathFieldEmbedBlot.scope = Parchment.Scope.INLINE;
//
// Quill.register(MathFieldEmbedBlot, true);
